import Swal from 'sweetalert2'
import axios from 'axios'

/** Lê a sessão salva no navegador (ou null). */
function sessao() {
    try {
        const s = JSON.parse(localStorage.getItem('dadosusuario') || 'null')
        return s && typeof s === 'object' ? s : null
    } catch (e) {
        return null
    }
}

let avisouExpirado = false

export default {

    // Defina VUE_APP_SERVIDOR no .env.local para apontar para outro backend
    // (ex.: http://localhost/r-rep em desenvolvimento).
    servidor : process.env.VUE_APP_SERVIDOR || 'https://dmini.sistemizeapps.com/r-rep',

    sessao,

    /**
     * O usuário tem a permissão (ou uma da lista)? Administrador tem todas.
     * Sessões antigas (antes das permissões) contam como administrador; o
     * servidor confere de qualquer jeito.
     */
    pode(perm, usuario) {
        const u = usuario || sessao()
        if (!u) return false
        if (u.admin === undefined || u.admin) return true
        const lista = Array.isArray(perm) ? perm : [perm]
        return (u.permissoes || []).some(p => lista.includes(p))
    },

    token() {
        const s = sessao()
        return s && s.token ? s.token : ''
    },

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    },

    /**
     * POST multipart padrão do sistema. O token da sessão é anexado
     * automaticamente; sessão expirada (401) leva de volta ao login.
     */
    reqaxios(parametros, metodo, url){
        const bodyFormData = new FormData();
        let temToken = false;
        let temEmpresa = false;
        for (let i = 0; i < parametros.length; i++){
            if (parametros[i].parametro === 'token') temToken = true;
            if (parametros[i].parametro === 'idempresa') temEmpresa = true;
            bodyFormData.append(parametros[i].parametro, parametros[i].valor);
        }
        if (!temToken && this.token()) bodyFormData.append('token', this.token());
        // Telas antigas (ex.: upload de arquivos) não enviavam a empresa.
        const s = sessao();
        if (!temEmpresa && s && s.idempresa) bodyFormData.append('idempresa', s.idempresa);

        return axios({
            method: metodo,
            url : url,
            data: bodyFormData,
            headers: {'Content-Type': 'multipart/form-data' }
        }).catch((erro) => {
            if (erro.response && erro.response.status === 403) {
                const msg = typeof erro.response.data === 'string' ? erro.response.data.replace(/^\s*[EI] - /, '') : 'Acesso não permitido.'
                Swal.fire({ icon: 'warning', title: 'Sem permissão', text: msg })
            }
            if (erro.response && erro.response.status === 401 && sessao()) {
                if (!avisouExpirado) {
                    avisouExpirado = true
                    Swal.fire({ icon: 'info', title: 'Sessão expirada', text: 'Faça login novamente.' })
                        .then(() => this.logoff(false))
                }
            }
            throw erro
        });
    },

    /** Monta URL GET (relatórios/impressões) já com empresa e token. */
    urlComToken(caminho, params) {
        const s = sessao() || {}
        const q = new URLSearchParams(Object.assign({ idempresa: s.idempresa, token: s.token }, params || {}))
        return this.servidor + caminho + '?' + q.toString()
    },

    notif(tipo, titulo, texto){
        if(tipo == 'error'){
            Swal.fire({ icon: "error", title: titulo, text: texto });
        }else{
            Swal.fire({
                position: "top-end",
                title: titulo,
                text: texto,
                showConfirmButton: false,
                timer: 1500,
                icon: tipo
            });
        }
    },

    /** Trata o retorno padrão "E - mensagem" / "I - mensagem" do backend. */
    respostaOk(data) {
        if (typeof data === 'number') return true
        if (typeof data === 'string' && /^\s*\d+\s*$/.test(data)) return true
        const msg = typeof data === 'string' ? data.replace(/^\s*[EI] - /, '') : 'Erro inesperado no servidor.'
        this.notif('error', 'Atenção', msg)
        return false
    },

    formatarvalor(value, cifra) {
        var val = (value / 1).toFixed(2).replace('.', ',');
        if (cifra == '') {
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        } else {
            return cifra + ' ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
    },
    dataBR(iso) {
        if (!iso) return ''
        const [a, m, d] = String(iso).substring(0, 10).split('-')
        return `${d}/${m}/${a}`
    },
    gerardadoslegendagrafico(arraydados){
        return arraydados.map(item => item.name);
    },
    resetZoom() {
        const metaViewport = document.querySelector('meta[name="viewport"]');
        if (metaViewport) {
          metaViewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
        }
    },
    DataBRtoObJ(dataStr){
        const partes = dataStr.split('/');
        if (partes.length !== 3) return null;
        return new Date(parseInt(partes[2], 10), parseInt(partes[1], 10) - 1, parseInt(partes[0], 10));
    },
    logoff(avisarServidor = true){
        const s = sessao()
        if (avisarServidor && s && s.token) {
            const fd = new FormData()
            fd.append('op', 'logout'); fd.append('idempresa', s.idempresa); fd.append('token', s.token)
            axios.post(this.servidor + '/controller/rotinalogin.php', fd).catch(() => {})
        }
        localStorage.removeItem('dadosusuario');
        window.location.href = '/';
    },
    getArrayIndexForKey(arr, key, val) {
        for (var i = 0; i < arr.length; i++) {
            if (arr[i][key] == val) return i;
        }
        return -1;
    },
    findValInArray(arr, key, val) {
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][key] == val) return true;
            }
        }
        return false;
    },
    getValInArray(arr, key, val, keyret) {
        if (arr) {
            for (var i = 0; i < arr.length; i++) {
                if (arr[i][key] == val) return arr[i][keyret];
            }
        }
        return 0;
    },
    limparCpfCnpj(valor){
        return valor.replace(/[.\-/]/g, '');
    },
    IsCEP(strCEP, blnVazio) {
        const objER = /^[0-9]{2}[0-9]{3}-[0-9]{3}$/;
        strCEP = String(strCEP).trim()
        if (strCEP.length > 0) return objER.test(strCEP);
        return blnVazio;
    },
    Trim(strTexto) {
        return String(strTexto).trim();
    },
    GerarStringAleatoria() {
        const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let straleat = "";
        for (let i = 0; i < 15; i++) {
            straleat += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return straleat;
    }
}
